import { Component, OnInit, Input } from "@angular/core";

@Component({
    selector: "emptyState",
    templateUrl: "./empty-state.component.html",
    styleUrls: ["./empty-state.component.scss"]
})
export class EmptyStateComponent implements OnInit {
    @Input() public icon: string;
    @Input() public title: string;
    @Input() public subtitle: string;
    @Input() public loading:boolean = false;

    constructor() { }

    public ngOnInit() {
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/empty-state/empty-state.component.ts